{
  "clusterServices": "Mine tenester",
  "allServices": "Alle tenester",
  "serviceCatalog": "Tenestekatalog",
  "activeServices": "Aktive tenester",
  "addService": "Legg til teneste",
  "editService": "Endre tjeneste",
  "notification.text": "Denne knappen tar deg til Felles tjenestekatalog. Du vil snart få moglegheita til å leggje til tenester inne i Flerbedriftsportalen.",
  "details.header": "Om tenesten",
  "details.validFrom": "Tenesten er gyldig fra",
  "details.validTo": "Tenesten er gyldig til",
  "details.description": "Beskrivelse av tenesta",
  "details.customerDescription": "Beskrivelse av tenesta for kunde",
  "details.purpose": "Formål med tenesten",
  "details.links": "Lenker",
  "details.targetAudience": "Målgruppe",
  "details.companyAge": "Krav til alder på bedrift",
  "details.companySize": "Krav til bedriftstørrelse",
  "details.customerSegment": "Relevant for utvalgte kundesegment",
  "details.customerSegmentComment": "Kommentar til kundesegment",
  "details.delivery": "Leveranse",
  "details.deliveryType": "Leveransetype",
  "details.deliveryDescription": "Hvordan tenesten leveres",
  "details.deadline": "Søknadsfrist",
  "details.userFee": "Brukerbetaling",
  "details.userFeeComment": "Kommentar til brukerbetaling",
  "details.contact": "Leverandør og kontaktinfo",
  "details.origin": "Leverandør",
  "details.contract": "Oppdragsgiver",
  "details.EEA": "EØS-artikler",
  "details.EEAarticles": "EØS-artikler som anvendes",
  "details.Error": "Kunne ikke hente teneste. Prøv igjen eller kontakt support.",

  "form.edit": "Rediger teneste",
  "form.publish": "Publiser",
  "form.publishChanges": "Publiser endringar",
  "form.saveAsDraft": "Lagre og lukk",
  "form.deleteDraft": "Slett utkast",
  "form.next": "Neste",
  "form.back": "Forrige",
  "form.add": "Legg til",
  "form.edit.button": "Rediger",
  "form.yes": "Ja",
  "form.no": "Nei",

  "about.title": "Om tenesta",
  "about.serviceName.label": "Kva er namnet på tenesta?",
  "about.serviceName.help": "Oppgi det norske namnet på tenesta slik det blir brukt i kundedialog og på nettsida.",
  "about.serviceName.required": "Ver snill og skriv namnet på tenesta",
  "about.serviceName.maxLength": "Tenestenamnet kan maksimalt være 500 tegn",
  "about.validFrom.label": "Tenesta er gyldig frå",
  "about.validFrom.required": "Ver snill og oppgi dato tenesta er gyldig frå",
  "about.validTo.label": "Tenesta er gyldig til",
  "about.validTo.required": "Ver snill og oppgi dato tenesta er gyldig til",
  "about.validTo.beforeValidFrom": "Gyldig til-datoen kan ikkje vere før gyldig frå-datoen",
  "about.description.label": "Korleis vil du skildre tenesta?",
  "about.description.help": "Skilder kort innhaldet i tenesta som om du forklarer det til nokon som ikkje har høyrt om ho før.",
  "about.description.required": "Ver snill og skilder innhaldet i tenesta",
  "about.purpose.label": "Kva er formålet med tenesta?",
  "about.purpose.help": "Skilder kort kvifor denne tenesta blir tilbydd. Forklar kva effekt tenesta skal gi for samfunnet/næringslivet. Er det konkrete effektar som oppdragsgjevaren vil oppnå? Kva gjer tenesta viktig for samfunnet?",
  "about.purpose.required": "Ver snill og skilder formålet med tenesta",
  "about.purpose.maxLength": "Formålet kan maksimalt være 500 teikn",
  "about.keywords.label": "Kva nøkkelord er relevante for tenesta? (Legg til eitt og eitt ord)",
  "about.keywords.help": "Skriv nøkkelord som ofte blir brukt når denne tenesta er relevant. Desse orda blir brukt i søk og algoritmar.",
  "about.keywords.required": "Ver snill og legg til nøkkelord",
  "about.links.title": "Kva lenker er relevante for tenesta?",
  "about.links.help": "Legg inn lenker som er særleg relevante for rådgjevarar eller kundar.",
  "about.links.text": "Tekst som blir vist",
  "about.links.url": "Skriv inn URL",
  "about.customerDescription.label": "Korleis vil du skildre tenesten som eit innsal til kunde i e-post?",
  "about.customerDescription.help": "Skildre tenesten for kunde. Skildringa brukes i e-poster til kunde når dei får anbefalt tenesten.",

  "target.title": "Målgruppe og geografisk nedslagsfelt",
  "target.companyAge.label": "Er det krav til alderen på bedrifta?",
  "target.companyAge.help": "Vel krav til alderen på bedrifta.",
  "target.companyAge.required": "Ver snill og vel eit alternativ",
  "target.companySize.label": "Er det krav til storleiken på bedrifta?",
  "target.companySize.help": "Vel krav til storleiken på bedrifta.",
  "target.companySize.required": "Ver snill og vel eitt eller fleire alternativ",
  "target.innovationLevelCriteria.placeholder": "Velg nivå",
  "target.innovationLevelCriteria.label": "Har tenesta krav til bedriftens innovasjonsnivå?",
  "target.innovationLevelCriteria.help": "Vel krav til bedriftens innovasjonsnivå.",
  "target.innovationLevelCriteria.required": "Ver snill og vel innovasjonsnivå",
  "target.innovationLevelCriteria.title": "Innovasjonsnivå",
  "target.innovationLevelCriteria.CompanyLevel": "Bedriftsnivå",
  "target.innovationLevelCriteria.RegionalLevel": "Regionalt nivå",
  "target.innovationLevelCriteria.NationalLevel": "Nasjonalt nivå",
  "target.innovationLevelCriteria.InternationalLevel": "Internasjonalt nivå",
  "target.innovationLevelCriteria.NotRelevant": "Ikke relevant",
  "target.innovationLevelCriteria.Unknown": "Ukjent",
  "target.customerSegment.label": "Er tenesta berre relevant for utvalte kundesegment?",
  "target.customerSegment.help": "Vel relevante kundesegment.",
  "target.customerSegment.required": "Ver snill og vel eitt eller fleire alternativ",
  "target.customerSegment.addComment": "Legg til kommentar",
  "target.customerSegment.comment.label": "Kommentar til kundesegment",
  "target.customerSegment.comment.help": "Utdjup her dersom tenesta rettar seg mot sektorspesifikke næringar.",
  "target.districtPolicy.label": "Må aktiviteten gjennomførast innanfor distriktspolitisk verkeområde?",
  "target.districtPolicy.help": "Er tenesta berre relevant for prosjekt innan distriktspolitisk verkeområde (DVP)? Vel Ja eller Nei.",
  "target.geographic.label": "For kva område gjeld tenesta?",
  "target.geographic.help": "Vel alle fylke/kommunar der du leverer denne tenesta.",
  "target.geographic.dialogTitle": "Legg til geografisk nedslagsfelt",
  "target.geographic.required": "Vennligst legg til minst ett fylke eller en kommune",

  "delivery.title": "Leveranse",
  "delivery.type.label": "Kva er primær leveransetype for tenesta?",
  "delivery.type.help": "Oppgi primær leveransetype/leveranseform for tenesta. Vel ein eller fleire.",
  "delivery.type.required": "Ver snill og vel eitt eller fleire alternativ",
  "delivery.description.label": "Korleis blir tenesta levert?",
  "delivery.description.help": "Skilder korleis tenesta blir levert. Blir tenesta t.d. levert via spesifikke aktørar eller assosierte konsulenter kan dette presiserast her.",
  "delivery.description.required": "Ver snill og skilder korleis tenesta blir levert",
  "delivery.deadline.question": "Blir tenesta levert gjennom utlysing med søknadsfrist?",
  "delivery.deadline.help": "Blir tenesta levert gjennom utlysing med søknadsfrist? Vel ja/nei.",
  "delivery.deadline.label": "Kva er søknadsfristen?",
  "delivery.deadline.helpText": "Set dato for søknadsfristen.",
  "delivery.deadline.required": "Ver snill og oppgi dato",
  "delivery.userFee.label": "Er det krav til brukarbetaling for å motta tenesta?",
  "delivery.userFee.help": "Er det krav til brukarbetaling for å motta tenesta? Dersom ja, bruk kommentarfeltet for vidare forklaring eller presisering.",
  "delivery.userFee.comment.label": "Har du ein kommentar til brukarbetaling?",
  "delivery.userFee.required": "Ver snill og vel eit alternativ",
  "delivery.userFeeComments.required": "Ver snill og legg til kommentar",

  "contact.title": "Kontaktinfo og leverandør",
  "contact.name.label": "Namn",
  "contact.name.help": "Informasjonen din blir sett automatisk, men du kan endre kven som er kontaktperson for tenesta.",
  "contact.name.required": "Ver snill og fyll inn namn på kontaktperson",
  "contact.email.label": "E-postadresse",
  "contact.email.required": "Ver snill og fyll inn e-postadresse",
  "contact.phone.label": "Telefonnummer",
  "contact.phone.required": "Ver snill og fyll inn telefonnummer",
  "contact.phone.maxLength": "Telefonnummer kan maksimalt være 15 tegn",
  "contact.supplier.question": "Kven leverer tenesta?",
  "contact.supplier.info": "Leverandørfeltet blir fylt ut automatisk frå profilinformasjonen.",
  "contact.client.question": "Kven er oppdragsgjevar?",
  "contact.client.info": "Leverandørfeltet blir fylt ut automatisk frå profilinformasjonen.",
  "contact.client.placeholder": "Ver snill og legg til oppdragsgjevar",
  "contact.client.dialogTitle": "Legg til oppdragsgjevar",
  "contact.client.required": "Vennligst legg til minst én oppdragsgiver",

  "eea.title": "EØS-artiklar",
  "eea.applies.label": "Nyttar tenesta EØS-artiklar?",
  "eea.applies.help": "Svar nei dersom tenesta ikkje nyttar EØS-artiklar.",
  "eea.articles.question": "Kva EØS-artiklar blir nytta?",
  "eea.articles.help": "Vel ein eller fleire EØS-artiklar frå lista for å oppgi kva som blir nytta.",
  "eea.articles.placeholder": "Ver snill og legg til nytta artiklar",
  "eea.articles.dialogTitle": "Legg til EØS-artiklar",
  "eea.comments.label": "Har du kommentarar til EØS-artiklane?",
  "eea.comments.help": "Utdjup her ved presisering.",
  "eea.comments.outsideLabel": "Har du kommentarar til kvifor tenesta fell utanfor EØS-regelverket?",
  "eea.comments.outsideHelp": "Utdjup kvifor tenesta fell utanfor EØS-regelverket.",
  "eea.comments.maxLength": "Maksimalt 500 teikn",

  "summary.title": "Oppsummering",
  "summary.inactiveWarning.title": "For at tenesta skal få status \"Aktiv\" må du endre følgjande:",
  "summary.inactiveWarning.validFrom": "må vere i dag eller tidlegare enn dagens dato",
  "summary.inactiveWarning.validTo": "må vere i dag eller etter dagens dato",

  "errors.fillRequired": "Ver snill og fyll ut alle påkravde felt",
  "errors.nameRequired": "Ver snill og skriv namnet på tenesta",

  "toasts.created": "Tenesta er oppretta",
  "toasts.published": "Tenesta er publisert",
  "toasts.draftSaved": "Utkastet er lagra",
  "toasts.draftDeleted": "Utkastet er sletta",
  "toasts.error": "Noko gjekk gale",

  "missingServices": "Du manglar tjenester",
  "missingServicesText": "Rediger tjenestene dine, slik at andre kan henvise til dei",

  "templates.info": "Du kan velje ein mal i lista under, eller bruke eit tomt skjema.",
  "templates.useTemplate": "Bruk mal",
  "templates.emptyForm": "Bruk tomt skjema",

  "purpose": "Formål"
}
